import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const ADQUISICION_A1 = `${API_URL}/adquisicion/a1`;
const ADQUISICION_A2 = `${API_URL}/adquisicion/a2`;
const BORRADOR_SOLICITUD = `${API_URL}/adquisicion/borrador`;
const INSERT_PRESENTAR_SOLICITUD = `${API_URL}/adquisicion/presentada`;
const GET_PDF_A1A2 = `${API_URL}/adquisicion/solicitudAdquisicionA1A2`;
const GET_SOLICITUD = `${API_URL}/adquisicion`;
const UPDATE_BORRADOR = `${API_URL}/adquisicion`;
const UPDATE_BORRADOR_PRESENTAR = `${API_URL}/adquisicion/updatePresentada`;
const GET_DATA = `${API_URL}/adquisicion/informacion`;

export async function getDataAdqusicion() {
  return await axios({
    method: "GET",
    url: GET_DATA,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo al recoger los datos de Adquisición")
    );
}
export async function getSolicitudesA1() {
  return await axios({
    method: "GET",
    url: ADQUISICION_A1,
  })
    .then((response) => {
      
      return response.data
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo al recoger los datos de Adquisición A1")
    );
}
export async function getSolicitudesA2() {
  return await axios({
    method: "GET",
    url: ADQUISICION_A2,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo al recoger los datos de Adquisición A2")
    );
}
export async function sendBorrador(valores) {
  return await axios({
    method: "POST",
    url: BORRADOR_SOLICITUD,
    data: valores,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al enviar el Borrador")
    );
}
export async function presentarSolicitud(valores) {
  return await axios({
    method: "POST",
    url: INSERT_PRESENTAR_SOLICITUD,
    data: valores,
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo al prentar solicitud"));
}
export async function updateBorradorAPresentada(valores) {
  return await axios({
    method: "PUT",
    url: UPDATE_BORRADOR_PRESENTAR,
    data: valores,
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo al prentar solicitud"));
}
export async function updateBorrador(id,valores) {
  return await axios({
    method: "PUT",
    url: `${UPDATE_BORRADOR}/${id}`,
    data: valores,
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo al prentar solicitud"));
}

export async function getPDFA1A2(id,tipo) {
  // 
  // enviar parametros como dni por e.j. para realizar la query en el back

  return await axios({
    method: "GET",
    url: `${GET_PDF_A1A2}/${id}/${tipo}`,
    responseType: "blob",
    //   params: { dni: dni },
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error:"));
}

export async function getSolicitud(id) {
  return await axios({
    method: "GET",
    url: `${GET_SOLICITUD}/${id}`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al enviar el Borrador")
    );
}
